import { Injectable, inject, Signal } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { CreateQueryResult, injectQuery, QueryClient } from '@tanstack/angular-query-experimental';
import { lastValueFrom } from 'rxjs';

import { BaseApi } from '@core/services/api/base.api';

@Injectable({ providedIn: 'root' })
export class AvatarApi extends BaseApi {
    private readonly baseQueryKey = 'avatars';
    private readonly queryClient = inject(QueryClient);

    public getAvatar(url: Signal<string | undefined>): CreateQueryResult<string, HttpErrorResponse> {
        return injectQuery<string, HttpErrorResponse>(() => {
            const avatarUrl = url();
            return {
                enabled: !!avatarUrl,
                queryKey: [this.baseQueryKey, avatarUrl],
                queryFn: async () => {
                    const blob = await lastValueFrom(this.getBlob(avatarUrl as string));
                    return URL.createObjectURL(blob);
                },
                staleTime: 1000 * 60 * 10, // 10 minutes — avatars change rarely
            };
        });
    }

    public async invalidateAll(): Promise<void> {
        await this.queryClient.invalidateQueries({ queryKey: [this.baseQueryKey] });
    }

    public async invalidate(url: string): Promise<void> {
        await this.queryClient.invalidateQueries({ queryKey: [this.baseQueryKey, url] });
    }
}
